
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/stalfalgar",
      function () {
        return require("private-next-pages/rims/stalfalgar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/stalfalgar"])
      });
    }
  